export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/08ee3b32e72dd5b2b700754671ea2016.svg";